<template>
  <div class="user-bg">
    <router-link to="/"><img class="user-logo" src="../../assets/img/logo.png"></router-link>
    <div class="user-container">
      <div class="form-container">
        <h3>{{$t("resetPwd.title")}}</h3>
        <div class="user-form">
          <el-form>
            <el-form :model="rstPwdForm" status-icon :rules="rstPwdRule" ref="rstPwdForm">
              <el-form-item prop="email" :label="$t('resetPwd.email')">
                <el-input type="email" v-model="rstPwdForm.email" autocomplete="off" @keyup.enter.native="submitForm">
                  <el-button slot="append" @click="getVerifyCode">{{$t("common.sendCode")}}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item prop="code" :label="$t('common.verifyCode')">
                <el-input v-model="rstPwdForm.code" @keyup.enter.native="submitForm"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm">{{$t("resetPwd.reset")}}</el-button>
              </el-form-item>
            </el-form>
          </el-form>
        </div>
      </div>
    </div>
    <div class="signUp">
      <p>{{$t("resetPwd.back")}}
        <router-link to="/login" class="go-regi">{{$t("resetPwd.login")}}</router-link>
      </p>
    </div>
  </div>
</template>
<script>
const resCode = require("../../../server/common/data").resCode;
import { resetPassword, sendVerifyCode } from "../../request";
import api from "../../api/api";
const validator = require('validator');

export default {
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.emailRequried')));
      } else {
        if (validator.isEmail(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.emailFormat')));
        }
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.verifyCodeRequried')));
      } else {
        if (validator.isLength(value, {min: 6, max: 6}) && validator.isAlphanumeric(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.verifyCodeFormat')));
        }
      }
    };
    return {
      rstPwdForm: {
        email: "",
        code: ""
      },
      rstPwdRule: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.rstPwdForm.validate(valid => {
        if (valid) {
          let data = {
            email: this.rstPwdForm.email,
            code: this.rstPwdForm.code
          };
          resetPassword(this, data);
        } else {
          return false;
        }
      });
    },
    getVerifyCode() {
      this.$refs.rstPwdForm.validateField("email", err => {
        if (!err) {
          let data = {
            email: this.rstPwdForm.email,
            act: "reset password"
          };
          sendVerifyCode(this, data);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// FgtPwd.vue?62997a2c